// CHG-130 REQ-DHR-021/022: 프로젝트 일반 회의록 훅
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchGeneralMeetings,
  createGeneralMeeting,
  type CreateGeneralMeetingInput,
} from '../services/projectDocumentsService';

export function useGeneralMeetings(projectId: string, limit = 20) {
  return useQuery({
    queryKey: ['general-meetings', projectId, limit],
    queryFn: () => fetchGeneralMeetings(projectId, limit),
    enabled: !!projectId,
    staleTime: 30_000,
  });
}

export function useCreateGeneralMeeting(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateGeneralMeetingInput) => createGeneralMeeting(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['general-meetings', projectId] });
    },
  });
}
